module.exports = __webpack_public_path__ + "img/PT10.ec8a6300.png";